<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <router-link
            class="title"
            :to="{name: 'BookmarkList'}"
          >
            Bookmarks
          </router-link>
        </div>
      </div>
    </section>
    <section class="container loading-data">
      <div class="columns">
        <div class="column">
          <div class="box">
            <nav class="level is-mobile">
              <div class="level-left" />
              <div class="level-right">
                Total: {{ metadata.totalCount }}
              </div>
            </nav>
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th style="width:20px">
                    <b-checkbox v-model="allChecked" />
                  </th>
                  <th>Id</th>
                  <th class="is-2">
                    Created At
                  </th>
                  <th class="is-2" />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(bookmark, index) in bookmarks"
                  :key="bookmark.id"
                >
                  <td>
                    <b-checkbox v-model="selected[index]" />
                  </td>

                  <td>
                    {{ bookmark.id }}
                  </td>

                  <td>
                    {{ $formatFullDate(bookmark.createdAt) }}
                  </td>

                  <td>
                    <div class="buttons">
                      <b-button
                        size="is-small is-danger"
                        icon-left="trash"
                        @click="confirmDelete(bookmark.id)"
                      />
                      <b-button
                        size="is-small is-warning"
                        icon-left="edit"
                        @click="editRecord(bookmark.id)"
                      />
                      <b-button
                        size="is-small is-default"
                        icon-left="eye"
                        @click="showRecord(bookmark.id)"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="columns is-mobile">
              <div class="column is-3">
                <b-button
                  v-if="multiActionable"
                  class="is-danger"
                  @click="confirmDelete()"
                >
                  Delete ({{ selectedIds.length }})
                </b-button>
              </div>

              <div class="column is-6">
                <b-pagination
                  v-if="metadata.totalCount > metadata.limitValue"
                  :total="metadata.totalCount"
                  :current.sync="currentPage"
                  :per-page="metadata.limitValue"
                  range-before="3"
                  range-after="3"
                  order="is-centered"
                  aria-next-label="Next page"
                  aria-previous-label="Previous page"
                  aria-page-label="Page"
                  aria-current-label="Current page"
                  class="pagination is-centered"
                />
              </div>

              <div class="column is-3">
                <b-button
                  class="is-primary is-pulled-right"
                  @click="newRecord()"
                >
                  New
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { paginationMixin, showMixin } from '@/mixins/crud/pagination'

  export default {
    name: 'BookmarksListTable',
    mixins: [ paginationMixin('bookmark', 'id'), showMixin('bookmark') ],
    computed: {
      ...mapGetters({
        bookmarks: 'bookmarks/all'
      })
    },
    mounted() {
      this.load({page: 1})
    },
    methods: {
      confirmDelete(id) {
        showMixin().methods.confirmDelete.call(this, id)

        this.$buefy.dialog.confirm({
          title: 'Deleting Bookmark',
          message: 'Are you sure you want to <b>delete</b> the selected bookmarks?',
          confirmText: 'Delete',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => this.deleteSelected(id),
          onCancel: () => this.cancelSelected()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.favicon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 4px;
}
</style>
